<template>
    <v-flex pa-2 shrink>
        <v-card class="weatherCard">
            <v-layout>
                <v-flex xs8>
                   <v-card-title class="subheading">{{ weather.TemperatureDate | formatDate }}</v-card-title>
                </v-flex>
                <v-flex xs4 class="text-xs-right" mr-2 mt-1>
                    <weatherIcon :WeatherIconName="weather.Icon" :width="64" :height="64"></weatherIcon>
                </v-flex>
            </v-layout>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-tile>
                    <v-list-tile-content style="max-width:180px; height:auto;">{{ weather.Summary }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Temperature Max:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ weather.TemperatureMax | formatNumberTo0Decimals }} &#8451;</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                    <v-list-tile-content>Temperature Min:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ weather.TemperatureMin | formatNumberTo0Decimals }} &#8451;</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                    <v-list-tile-content>Humidity:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ weather.Humidity | formatDecimalToPercentageInt }}</v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>
    </v-flex>
</template>

<script>
import weatherIcon from '@/components/harvestPlan/WeatherIcon';

export default {
    components: {
        weatherIcon
    },
    props: ["weather"],
    data() {
        return {
            
        };
    }
}
</script>

<style>
    .weatherCard {
        width: 250px;
        height: 250px;
    }
</style>
